import {Form, Input} from 'decorator-form';

import InputType from 'common/form/InputType';
import {TypographyStylesConfig, typographyStylesInput} from '../common/TypographyStylesConfig';

@Form({title: "Heading View Config"})
export default class HeadingViewConfig {

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color?: string;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string;

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding?: string;

	@Input({type: InputType.UNIT, title: "Max-width"})
	public maxWidth?: string;

	@Input({type: InputType.BORDER, title: "Separator"})
	public separator: string = "0px 0px 0px 0px";

	@Input({type: typographyStylesInput, title: "Text Style"})
	public typography: TypographyStylesConfig;

	@Input({type: InputType.NUMBER, title: "Line clamp (vertical)"})
	public lineClamp: number;

	@Input({type: InputType.NUMBER, title: "Words per line"})
	public wordsPerLine: number;

}



// WEBPACK FOOTER //
// ./src/common/views/heading/HeadingViewConfig.ts